import { Helmet } from 'react-helmet-async';
import { useBranding } from '../../contexts/SiteContext';

interface PageSeoProps {
  title?: string | null;
  description?: string | null;
  ogImage?: string | null;
  canonical?: string;
  noindex?: boolean;
}

export function PageSeo({ title, description, ogImage, canonical, noindex }: PageSeoProps) {
  const branding = useBranding();
  const fullTitle = title ? `${title} — ${branding.name}` : branding.name;
  const canonicalUrl = canonical ?? (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />

      {/* Canonical */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
